(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["featured-slider"] && !window.DesignMode) return;
  try {
    

  $('.featured-slider').click(function(){$('.hero_tooltip').fadeOut();$('.featured-slider').addClass('open');});
  $('.hero_tooltip').click(function(){$('.hero_tooltip').fadeOut();$('.featured-slider').addClass('open');});



  } catch(e) { console.error(e); }
})();

})();
